import { getLocalDayOfWeek } from '@tesla/design-system';
import React from 'react';
/**
 * Generate days of the week from the days grid
 * Eg. "S M T W T F S"
 */
export const DaysOfWeek = ({ firstDayOfWeek = 0, locale = 'en-US', ...rest }) => {
    const days = [];
    // Set the first day to Sunday (TODO: Set first day based on locale?)
    const day = new Date();
    day.setDate(day.getDate() - day.getDay() + firstDayOfWeek);
    // Generate flat array for a 7 cell calendar grid
    for (let col = 0; col < 7; col++) {
        const thisDay = new Date(day);
        days.push(thisDay);
        day.setDate(day.getDate() + 1);
    }
    return (React.createElement("div", { className: "tds-date-picker-days-label", ...rest }, days.map((day, i) => (React.createElement("div", { className: "tds-day", key: `${day}_${i}` },
        React.createElement("strong", null, getLocalDayOfWeek(day, locale)))))));
};
